import React, { Suspense, lazy } from 'react';

import { RouteObject } from 'react-router-dom';

const MyInitiativesAndImpact = lazy(
  () =>
    import(
      '@pages/dashboard/SocialGoodAndDashboard/components/MyInitiativesAndImpact'
    ),
);
const SpreadMorePeaceOfMind = lazy(
  () =>
    import(
      '@pages/dashboard/SocialGoodAndDashboard/components/SpreadMorePeaceOfMind'
    ),
);

export const SocialGoodAndDashboardRoutes: RouteObject = {
  handle: {
    label: 'Social Good & Dashboard',
    skipBreadCrumb: true,
  },
  children: [
    {
      path: '/dashboard/initiatives-and-impact',
      handle: {
        label: 'My Initiatives & Impact',
        disabled: true,
      },
      element: (
        <Suspense>
          <MyInitiativesAndImpact />
        </Suspense>
      ),
    },
    {
      path: '/dashboard/peace-of-mind',
      handle: {
        label: 'Spread More Peace of Mind',
        disabled: true,
      },
      element: (
        <Suspense>
          <SpreadMorePeaceOfMind />
        </Suspense>
      ),
    },
  ],
};
